<template>
    <div class="invoice" id="invocie-list">
        <SOSlotBase :bg-grey="true" :is-search="isSearchOpen">
            <template v-slot:title-bar>
                <SOTitleBar
                    :page-title="page.title"
                    :type="'back'"
                    @back="back"
                    :show-search="true"
                    @search="onToggleSearch"
                    v-if="!isSearchOpen"
                />
            </template>
            <template v-slot:search-bar>
                <SOSearchBar
                    v-if="isSearchOpen"
                    :context="'Penjadwalan Ototmatis'"
                    :placeholder="`Ketik minimal 2 karakter`"
                    :value="search.key"
                    :data-count="countResults"
                    :search-information="`Nama dan No Telp konsumen.`"
                    :waiting="search.searching"
                    @do-search="doSearch"
                    @loading="onSearch"
                    @close="onToggleSearch"
                />
            </template>
            <template v-slot:empty-state>
                <div>
                    <SOEmptyState
                        v-if="!penjadwalanList.count && !isFetching && !isSearchOpen"
                        :message="'Tidak ada Penjadwalan'"
                        :subMessage="'Klik tombol + untuk menambah penjadwalan otomatis'"
                    />
                    <SOEmptySearchState
                        v-if="!countResults && !isFetching && isSearchOpen && search.key.length > 1"
                        @action="resetSearchFilter"
                    />
                </div>
            </template>
            <template v-slot:skeleton v-if="isFetching">
                <div class="p-x-20 p-y-16 w-limit">
                    <SOLoadSearch v-if="isSearchOpen" />
                    <CardSkeleton v-else />
                </div>
            </template>
            <template v-slot:content v-else>
                <!-- <SOInformation title="" myStyle="padding: 0 !important">
                    <template v-slot:subtitle>
                        <p class="m-d-0">
                            Sistem Akan Menjalankan Jadwal Otomatis Setiap Jam 23:00  WIB s/d 23:59 WIB
                        </p>
                    </template>
                </SOInformation> -->
                <div class="bg-white px-4 py-3">
                    <div class="">
                        <div class="d-flex-between-center m-d-2">
                            <span class="f-14 w-75">Estimasi penggunaan M-Coin saat Penjadwalan Dijalankan</span>
                            <!-- <span class="f-14 f-bold" v-if="Object.keys(kode_promo).length === 0">52.500</span> -->
                            <div>
                                <span class="f-14 f-c-midgrey p-1" style="text-decoration: line-through;" v-if="mcoinEstimation.ActiveCoupon">{{ mcoinEstimation.initialCoinEstimation }}</span>
                                <span class="f-14">{{ mcoinEstimation.totalCoinEstimation }}</span>
                            </div>
                        </div>
                        <div>
                            <div class="m-0 border border-primary rounded p-x-8" style="width: 180px;" v-if="!mcoinEstimation.ActiveCoupon">
                                <div class="d-flex-between-center">
                                    <p class="f-14 f-c-blue m-d-0 f-bold" @click="showPromoModal()">Masukkan Kode Promo</p>
                                    <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.146447 7.35355C-0.0488156 7.15829 -0.0488156 6.84171 0.146447 6.64645L2.79289 4L0.146446 1.35355C-0.0488158 1.15829 -0.0488158 0.841709 0.146446 0.646447C0.341708 0.451184 0.658291 0.451184 0.853553 0.646447L3.85355 3.64645C4.04882 3.84171 4.04882 4.15829 3.85355 4.35355L0.853553 7.35355C0.658291 7.54882 0.341709 7.54882 0.146447 7.35355Z" fill="#206CFF"/>
                                    </svg>
                                </div>
                            </div>
                            <div v-else class="d-flex-between-center">
                                <div class="m-0 border border-primary rounded p-1" style="width: 180px;" @click="showDetailPromoModal()">
                                    <div class="d-flex-between-center">
                                        <p class="f-14 f-c-blue m-d-0 f-bold text-uppercase">{{ mcoinEstimation.ActiveCoupon.kode }}</p>
                                        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 3.5H7V4C7 4.27614 7.22386 4.5 7.5 4.5C7.77614 4.5 8 4.27614 8 4V3.5H9.5C9.63261 3.5 9.75978 3.55268 9.85355 3.64645C9.94732 3.74022 10 3.86739 10 4V5.08579C9.79105 5.15967 9.59904 5.27964 9.43934 5.43934C9.15804 5.72065 9 6.10218 9 6.5C9 6.89783 9.15804 7.27936 9.43934 7.56066C9.59904 7.72036 9.79105 7.84033 10 7.91422V9C10 9.13261 9.94732 9.25979 9.85355 9.35356C9.75978 9.44732 9.63261 9.5 9.5 9.5H8V9C8 8.72386 7.77614 8.5 7.5 8.5C7.22386 8.5 7 8.72386 7 9V9.5H2.5C2.36739 9.5 2.24021 9.44732 2.14645 9.35356C2.05268 9.25979 2 9.13261 2 9V7.91422C2.20895 7.84033 2.40096 7.72036 2.56066 7.56066C2.84196 7.27936 3 6.89783 3 6.5C3 6.10218 2.84196 5.72065 2.56066 5.43934C2.40096 5.27964 2.20895 5.15967 2 5.08579V4C2 3.86739 2.05268 3.74021 2.14645 3.64645C2.24021 3.55268 2.36739 3.5 2.5 3.5ZM2.5 2.5C2.10218 2.5 1.72064 2.65804 1.43934 2.93934C1.15804 3.22064 1 3.60218 1 4V5.5C1 5.77614 1.22386 6 1.5 6C1.63261 6 1.75979 6.05268 1.85355 6.14645C1.94732 6.24022 2 6.36739 2 6.5C2 6.63261 1.94732 6.75979 1.85355 6.85355C1.75979 6.94732 1.63261 7 1.5 7C1.22386 7 1 7.22386 1 7.5V9C1 9.39783 1.15804 9.77936 1.43934 10.0607C1.72064 10.342 2.10217 10.5 2.5 10.5H9.5C9.89783 10.5 10.2794 10.342 10.5607 10.0607C10.842 9.77936 11 9.39783 11 9V7.5C11 7.22386 10.7761 7 10.5 7C10.3674 7 10.2402 6.94732 10.1464 6.85355C10.0527 6.75979 10 6.63261 10 6.5C10 6.36739 10.0527 6.24022 10.1464 6.14645C10.2402 6.05268 10.3674 6 10.5 6C10.7761 6 11 5.77614 11 5.5V4C11 3.60218 10.842 3.22064 10.5607 2.93934C10.2794 2.65804 9.89783 2.5 9.5 2.5H2.5ZM7.5 5.5C7.77614 5.5 8 5.72386 8 6V7C8 7.27614 7.77614 7.5 7.5 7.5C7.22386 7.5 7 7.27614 7 7V6C7 5.72386 7.22386 5.5 7.5 5.5Z" fill="#206CFF"/>
                                        </svg>
                                    </div>
                                </div>
                                <div @click="showPromoModal()">
                                    <span class="f-c-blue f-semi f-14">Ubah</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-x-20">
                    <div v-if="penjadwalanList.count || !isSearchOpen">
                        <div class="card_breadcrum p-t-16">
                            <SOHeaderList
                                :title="`${penjadwalanList.count} Jadwal`"
                                :show-filter="true"
                                @filter="toggleFilter(true)"
                            />
                        </div>
                        <div>
                            <CardList
                                type-card="shadow"
                                :data-list="penjadwalanList.data"
                                :search-key="search.key"
                                @deleteList="id => deleteList(id)"
                            />
                            <SOLoadMoreLoading
                                v-if="penjadwalanList.data.length < penjadwalanList.count"
                                :id="'load-more-penjadwalan-invoice'"
                                :loading="penjadwalanList.data.length < penjadwalanList.count"
                                @intersect="!isLoadingMore && loadMoreData()"
                            />
                        </div>
                    </div>
                    <div class="flying-button-wrapper" v-if="validateAccess('schedule.create')">
                        <div class="flying-inside">
                            <a class="flying-button" @click="()=>{$router.push({ name: 'invoicePenjadwalan.create' });    smartTrackingClick('add_penjadwalan_otomatis'); }"></a>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:filter>
                <div>
                    <FilterPenjadwalan
                        v-model="page.showFilter"
                        @do-filter="filter => loadData(filter)" 
                    />
                </div>
            </template>
            <template v-slot:modal>
                <SOModalConfirm
                    title="Hapus Jadwal Otomatis"
                    body="Apakah anda yakin akan menghapus jadwal ?dengan menghapus jadwal ini maka pembuatan otomatis tidak akan dijalankan."
                    button-text="Hapus Jadwal"
                    ref="confirmDeleteJadwal"
                    outline-danger
                    :primary="false"
                    :loading="page.deleting"
                    :disable="page.deleting"
                />
                <ModalPromo
                    @selected="val => kode_promo = val"
                    ref="modalPromo"
                    fitur="masal_transaksi_cron"
                />
                <DetailPromo
                    ref="detailPromo"
                />
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOModalConfirm from "@/so-components/global/modal/SOModalConfirm.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState.vue";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import ModalPromo from "../components/modals/ModalPromo.vue";
import DetailPromo from '../components/modals/DetailPromo';

import CardSkeleton from "../components/CardSkeleton.vue";
import CardList from "../components/CardListPenjadwalan.vue";
import FilterPenjadwalan from "../components/FilterInvoiceJadwal.vue";
import SOInformation from "@/so-components/global/ui/SOInformation.vue";
import { search } from '../../penghapusan-transaksi/reguler/store/state';

export default {
    name: "penjadwalanList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOHeaderList,
        SOSearchBar,
        SOLoadSearch,
        SOLoadMoreLoading,
        SOEmptyState,
        SOEmptySearchState,
        CardSkeleton,
        CardList,
        FilterPenjadwalan,
        SOInformation,
        SOModalConfirm,
        ModalPromo,
        DetailPromo,
    },
    data() {
        return {
            page: {
                title: "Penjadwalan Otomatis",
                isLoading: false,
                isLoadingMore: false,
                deleting: false,
                showFilter: false,
            },
            search: {
                open: false,
                searching: false,
                key: "",
            },
            query: {},
            kode_promo: {},
        };
    },
    computed: {
        ...mapGetters(moduleName, {
            penjadwalanList: "penjadwalanList",
            mcoinEstimation: "mcoinEstimation",
        }),
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        countResults() {
            return this.penjadwalanList.count;
        },
        isSearchOpen() {
            return this.search.open;
        },
        isFetching() {
            return this.page.isLoading;
        },
        modulName() {
            return moduleName;
        },
    },
    mounted() {
        this.resetFilter();
        this.loadData();
        this.getCoinEstimation();
        this.smartTrackingView('penjadwalan_otomatis')

    },
    methods: {
        ...mapActions({
            getListPenjadwalan: `${moduleName}/getListPenjadwalan`,
            deletePenjadwalan: `${moduleName}/deletePenjadwalan`,
            setFilter: `${moduleName}/setFilter`,
            resetPage: `${moduleName}/resetPage`,
            getCoinEstimation: `${moduleName}/getCoinEstimation`,
        }),
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");
            let temp = {
                ...this.filterItem,
                filter_periode_by: "1",
            };
            await this.$store.commit("filterGlobalModule/setFilterItem", temp);
        },
        toggleFilter(val) {
            console.log(val);
            this.page.showFilter = val;
        },
        defaultQuery() {
            return {
                start_date: null,
                end_date: null,
                limit: 20,
                index: 0,
                filter_periode_by: null,
                jenis_periode: null,
                pengulangan: null,
                search: null,
                status_dijalankan: null,
                search: null,
            }
        },
        async loadData(filter) {
            this.page.isLoading = true
            this.$store.commit('invoiceModule/resetPenjadwalanList');
            this.query = filter ? Object.assign(this.query, filter) : this.defaultQuery();
            try {
                const res = await this.getListPenjadwalan(this.query);
            } catch (error) {
                this.$toast.error(error.msg);
            }
            this.page.isLoading = false
            this.onSearch(false);
        },
        async loadMoreData() {
            this.query.index = this.penjadwalanList.data.length;
            await this.getListPenjadwalan(this.query);
        },
        async deleteData(id) {
            this.page.deleting = true;
            const res = await this.deletePenjadwalan(id)
            this.page.deleting = false;
            this.$refs.confirmDeleteJadwal.close();
            if (res.success) {
                this.$toast.success('Jadwal berhasil dihapus')
            this.loadData()
            }
            else {
                this.$toast.error('Gagal menghapus jadwal. ' + res.message)
            }
        },
        deleteList(id) {
            this.$refs.confirmDeleteJadwal.open().then(isAccept => {
                if (isAccept) {
                    this.deleteData(id)
                }
            })
        },
        back() {
            this.$router.go(-1);
        },
        onSearch(val) {
            this.search.searching = val;
        },
        onToggleSearch() {
            this.search.open = !this.search.open;
            if (!this.search.open) {
                this.search.key = "";
                this.loadData();
            }
        },
        doSearch(key) {
            let filter = this.defaultQuery();
            filter.search = key;
            this.loadData(filter);
        },
        scrollTo() {
            let el = document.getElementById(this.invoiceView.id);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        showPromoModal() {
            this.$refs.modalPromo.open();
        },
        showDetailPromoModal() { 
            this.$refs.detailPromo.open();
        },
    },
};
</script>